import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import Guide from './Guide';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const guide = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/guides/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateGuide = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.guide : null;
};

const getGuideID = (props: RouteComponentProps<any>) => {
  return props.match.params.guideId;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedGuide = getStateGuide(props);

    if (preloadedGuide) {
      return <Component guide={preloadedGuide} />;
    }

    if (getGuideID(props) === 'new') {
      return (
        <Component
          guide={{
            name: null,
            description_text: null,
            steps: [],
            image_identifier: null,
            compay: null,
            user: context.profile,
          }}
        />
      );
    }

    const state = guide(getGuideID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component guide={state.data} />;
  };
}

export default withState(Guide);
